import React from 'react';

import { Event } from '../../interfaces';

import { Thumbnail } from '.';

import '../../assets/stylesheets/components/sub-events-thumb.scss';

interface Props {
  event: Event;
}

export function SubEventsThumb(props: Props) {
  const { event } = props;
  const { sub_events } = event;

  return (
    <div className="hdn-sub-events-thumb">
      <Thumbnail event={event} onClick={() => false} width={208} height={126} />
      <Thumbnail event={sub_events[1]} onClick={() => false} width={208} height={126} />
      {sub_events[2] && <Thumbnail event={sub_events[2]} onClick={() => false} />}
      {sub_events.length > 3 && <div className="counter">+{sub_events.length - 3}</div>}
    </div>
  );
}
